export interface AppConfig {
  realtimeUrl: string;
  apiUrl: string;
  zoneId: string;
  zoneInstance: string;
}

export interface FeatureFlags {
  sentry: boolean;
  analytics: boolean;
  voiceForceRelay: boolean;
}

const env = import.meta.env;

export const config: AppConfig = {
  realtimeUrl: env.VITE_REALTIME_URL ?? "ws://localhost:4000/socket",
  apiUrl: env.VITE_API_URL ?? "http://localhost:4000",
  zoneId: env.VITE_ZONE_ID ?? "glade",
  zoneInstance: env.VITE_ZONE_INSTANCE ?? "auto",
};

// `?voice_relay=1` URL query overrides the env flag for ad-hoc testing
// without a rebuild. Useful when diagnosing ICE failures from a single
// client without affecting other tabs/users on the same build.
const voiceRelayQuery =
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("voice_relay") === "1";

export const features: FeatureFlags = {
  sentry: env.VITE_ENABLE_SENTRY === "true",
  analytics: env.VITE_ENABLE_ANALYTICS === "true",
  voiceForceRelay: env.VITE_VOICE_FORCE_RELAY === "true" || voiceRelayQuery,
};

export const WORLD = {
  width: 960,
  height: 700,
  tickRateMs: 50,
  moveSendIntervalMs: 50,
} as const;

export const MUSIC = {
  /** Distance (game units) at which spatial volume reaches 0 */
  SPATIAL_MAX_DIST: 600,
  /** Distance at which a spatial WebRTC connection is established/dropped */
  SPATIAL_CONNECT_DIST: 900,
  RTC_ICE_SERVERS: [{ urls: "stun:stun.google.com:19302" }] as RTCIceServer[],
} as const;
